import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Input, Checkbox } from 'react-toolbox';
import cx from 'classnames';
import { isString } from 'lodash';
import PhoneInput from 'components/PhoneType/PhoneInput';
import FlexBox from 'flexbox-react';
import styles from 'styles/form';
import common from 'styles/common';
import { nestedError } from '../../../../../utils';
import ColoredButton from 'components/ColoredButton';
import { PHONE_TYPES_W_FAX } from 'config/constants';
import PhoneType from 'components/PhoneType';
import DatePicker from 'components/DatePicker';
import RTCheckbox from 'styles/checkbox.scss';

const removeButton = cx(styles.deleteChildButton, styles.cancelButton, common.floatLeft);

class HelperForm extends Component {
  constructor(props) {
    super(props);
    const { onDisable, index, onChange, onDelete } = this.props;
    this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
    this.handleDelete = () => onDelete(this.props.helper.id);
    this.showError = nestedError.bind(this, 'helpers', index);
    this.onDisable = onDisable.bind(this);
    this.onNameChange = onChange.bind(this, 'name');
    this.onPhoneNumberChange = onChange.bind(this, 'phone_number');
    this.onPhoneNumberTypeChange = onChange.bind(this, 'phone_number_type');
    this.onEmailChange = onChange.bind(this, 'email');
    this.onBadgeNumberChange = onChange.bind(this, 'badge_number');
    this.onBadgeLinkChange = onChange.bind(this, 'badge_link');
    this.onBadgeExpirationChange = onChange.bind(this, 'badge_expiration');
  }

  handleCheckboxChange = value => this.props.onChange('not_used', value);

  render = () => {
    const { errors, helper, helperFieldWarnings, fieldError } = this.props;
    const largeInput = cx(styles.childInputs, styles.largeInput);
    const isSavedHelper = !isString(helper.id) || helper.id.indexOf('new_') !== 0;
    return (<div className={styles.childCard}>
      <FlexBox>
        <Input
          label="Name"
          value={helper.name || ''}
          className={largeInput}
          error={this.showError('name', errors)}
          required
          onChange={this.onNameChange}
        />
        <PhoneInput
          label="Phone Number"
          type="tel"
          value={helper.phone_number || ''}
          className={largeInput}
          error={this.showError('phone_number', errors)}
          onChange={this.onPhoneNumberChange}
        >
          <PhoneType
            source={PHONE_TYPES_W_FAX}
            value={helper.phone_number_type}
            onChange={this.onPhoneNumberTypeChange}
          />
        </PhoneInput>
        <Input
          label="Email Address"
          value={helper.email || ''}
          className={largeInput}
          error={fieldError('email', helperFieldWarnings)}
          onChange={this.onEmailChange}
        />
      </FlexBox>
      <FlexBox>
        <Input
          label="Badge Number"
          value={helper.badge_number || ''}
          className={largeInput}
          error={this.showError('badge_number', errors)}
          required
          onChange={this.onBadgeNumberChange}
        />
        <DatePicker
          label="Badge expiration"
          className={largeInput}
          value={helper.badge_expiration || ''}
          onChange={this.onBadgeExpirationChange}
          error={this.showError('badge_expiration', errors)}
          required
        />
        <Input
          label="Badge Link"
          value={helper.badge_link || ''}
          className={largeInput}
          error={this.showError('badge_link', errors)}
          required
          onChange={this.onBadgeLinkChange}
        />
      </FlexBox>
      <FlexBox justifyContent="space-between">
        <Checkbox
          checked={helper.not_used}
          label="Do not use"
          theme={RTCheckbox}
          className={styles.checkboxItem}
          onChange={this.handleCheckboxChange}
        />
        <div>
          {isSavedHelper ? null : (<ColoredButton
            className={removeButton}
            color="red"
            label="Remove"
            onClick={this.handleDelete}
          />)}
          <ColoredButton
            className={styles.deleteChildButton}
            color={helper.disabled ? 'green' : 'darkGray'}
            label={(helper.disabled ? 'Enable' : 'Disable').concat(' Helper')}
            onClick={this.onDisable}
          />
        </div>
      </FlexBox>
    </div>);
  }
}

HelperForm.propTypes = {
  index: PropTypes.number,
  onDelete: PropTypes.func,
  onChange: PropTypes.func,
  onDisable: PropTypes.func,
  onSurfaceTypesChange: PropTypes.func,
  errors: PropTypes.object,
  helper: PropTypes.object,
  helperFieldWarnings: PropTypes.array,
  fieldError: PropTypes.func,
};

export default HelperForm;



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/installers/components/helperForm.jsx